<!-- Toolbar -->
<div class="mainContainer">
  <mat-toolbar color="primary">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <h1 *ngIf="calculationService.page != 'analysis'">Portfolio Builder</h1>
      <h1 *ngIf="calculationService.page == 'analysis'">Portfolio Analysis</h1>
      <button mat-raised-button (click)="toggleBuilder()">Toggle</button>
    </mat-toolbar-row>
  </mat-toolbar>
</div>

<div class="content" role="main">
  <app-builder></app-builder>
</div>

<app-footer></app-footer>